import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "currentColor",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "nonzero",
    d: "M12.049 6.424a5.848 5.848 0 1 1 0 11.695 5.848 5.848 0 0 1 0-11.695m0 1.5a4.348 4.348 0 1 0 0 8.695 4.348 4.348 0 0 0 0-8.695M18.44 4.632a.75.75 0 1 1 1.064 1.057l-1.14 1.147A.75.75 0 1 1 17.3 5.78zM5.514 17.485a.75.75 0 0 1 1.064 1.058l-.949.954a.75.75 0 1 1-1.064-1.058zM12.039 19.4a.75.75 0 0 1 .75.75v1.39a.75.75 0 1 1-1.5 0v-1.39a.75.75 0 0 1 .75-.75M21.307 11.058a.75.75 0 1 1 0 1.5h-1.853a.75.75 0 1 1 0-1.5zM17.78 17.294a.75.75 0 0 1 1.06 0l1.144 1.143a.75.75 0 1 1-1.06 1.06l-1.144-1.142a.75.75 0 0 1 0-1.061"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12.049 9.027a3.244 3.244 0 1 0 0 6.488" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "nonzero",
    d: "M4.624 11.521a.75.75 0 1 1 0 1.5H2.771a.75.75 0 1 1 0-1.5zM5.041 4.63a.75.75 0 0 1 1.061 0l.951.952a.75.75 0 1 1-1.06 1.06l-.952-.951a.75.75 0 0 1 0-1.06M12.039 1.79a.75.75 0 0 1 .75.75v1.853a.75.75 0 1 1-1.5 0V2.54a.75.75 0 0 1 .75-.75"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }